export default __webpack_public_path__ + "static/media/ic_comprar_medicamento.44a709b5.svg";